import { render, staticRenderFns } from "./ProductInput.vue?vue&type=template&id=f4d4ccfe&scoped=true&"
import script from "./ProductInput.vue?vue&type=script&lang=js&"
export * from "./ProductInput.vue?vue&type=script&lang=js&"
import style0 from "./ProductInput.vue?vue&type=style&index=0&id=f4d4ccfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d4ccfe",
  null
  
)

export default component.exports